import { fromJS } from 'immutable';
import * as ACTIONS from '../containers/constants';

const initialState = fromJS({});

export function settingsReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.SETTINGS_UPDATE:

      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}

export default settingsReducer;
